import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'
import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { confirmDelete } from '@functions/entity'

import { generateUrls } from '@hooks/useProvider'
import useBrandProvider from '@hooks/useBrandProvider'

import { BrandProviderModel } from '@domain-group/realhub-backend-api-types'

interface BrandProviderProps {
  brandProvider: BrandProviderModel,
}

const BrandProvider = (props: BrandProviderProps) => {
  const { brandProvider } = props

  const { callbacks: { deleteBrandProvider: deleteFn }, provider } = useBrandProvider(brandProvider)

  const { editProviderUrl } = generateUrls(provider)

  const confirmDeleteParams = {
    callbacks: {
      deleteFn,
    },
    strings: {
      deleteString: 'remove',
      entityName: 'Provider',
    },
  }

  return (
    <DashboardModuleListItem
      key={provider?.id}
      title={provider?.title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText># {provider?.id}</DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          icon={faTrashAlt}
          // @ts-expect-error TS2345
          onClick={() => confirmDelete(confirmDeleteParams)}
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editProviderUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default BrandProvider
